import Vue from 'vue'
import App from './App.vue'
import Vuex from 'vuex'
import store from "./store/index.js";
import utils from "./plugins/utils";
import vuetify from './plugins/vuetify'
import router from './router/index'
import {axios, registerStore} from './plugins/http-axios';
import { copyEmailWithToast } from './plugins/copyToClipboard';
import moment from 'moment';
import '@mdi/font/css/materialdesignicons.css'

import VueYandexMetrika from 'vue-yandex-metrika'

import VueObserveVisibility from 'vue-observe-visibility'

import "./style/common.css";
import "./style/text.css";
import "./style/color.css";
import "./style/mobile.css";
import "./style/tablet.css";
import "./style/mac.css";
import "./style/computer.css";

import globalUIParameters from './mixins/global-ui-parameters';

Vue.use(Vuex)
Vue.use(VueObserveVisibility)

Vue.mixin(globalUIParameters)


Vue.use(VueYandexMetrika, {
    id: 103490716,
    router: router,
    env: process.env.NODE_ENV,
    options: {clickmap:true, trackLinks:true, accurateTrackBounce:true, webvisor:true}
})

Vue.prototype.$moment = moment;
Vue.prototype.$utils = utils;
Vue.prototype.$axios = axios;

// Глобальный шорткат для копирования email с уведомлением.
// Использование в шаблоне: @click.prevent="$copyEmail('info@example.com')"
Vue.prototype.$copyEmail = function (email) {
    return copyEmailWithToast(this.$store, email);
};

// Регистрируем store в http-axios для глобальной обработки 401 / X-Refreshed-Token
registerStore(store);

Vue.config.productionTip = false

new Vue({
    store,
    vuetify,
    router,
    render: h => h(App)
}).$mount('#app')
